import React from 'react';
import { useConfiguration } from '../../context/configurationContext';
import { useIntl } from '../../util/reactIntl';
import { patchPlaceholderFooter } from '../../util/footerHelpers';
import loadable from '@loadable/component';

const SectionBuilder = loadable(
  () => import(/* webpackChunkName: "SectionBuilder" */ '../PageBuilder/PageBuilder'),
  {
    resolveComponent: components => components.SectionBuilder,
  }
);

const FooterComponent = () => {
  const config = useConfiguration();
  const intl = useIntl();
  const { footer = {}, topbar, marketplaceName } = config;

  if (Object.keys(footer).length === 0) {
    return null;
  }

  const patchedFooter = patchPlaceholderFooter(footer, {
    marketplaceName: marketplaceName || 'BetterXchange',
    slogan: intl.formatMessage({ id: 'Footer.brandSlogan' }),
    copyright: intl.formatMessage(
      { id: 'Footer.copyright' },
      { year: new Date().getFullYear(), marketplaceName: marketplaceName || 'BetterXchange' }
    ),
  });

  const footerSection = {
    ...patchedFooter,
    sectionId: 'footer',
    sectionType: 'footer',
    linkLogoToExternalSite: topbar?.logoLink,
  };

  return <SectionBuilder sections={[footerSection]} />;
};

export default FooterComponent;
